import React, { PureComponent } from 'react'
import { Input } from "antd";

import "./InputDayMonth.css"

export default class InputDayMonth extends PureComponent {

  constructor(props) {
    super(props)

    this.state = {
      value: this.props.value,
      leftValue: undefined,
      rightValue: undefined
    }
  }

  componentDidMount() {
    this.setState({
      leftValue: InputDayMonth.lValue(this.props.value),
      rightValue: InputDayMonth.rValue(this.props.value)
    });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      leftValue: InputDayMonth.lValue(nextProps.value),
      rightValue: InputDayMonth.rValue(nextProps.value)
    }
  }

  static lValue = (value) => value && value.includes("/") && value.split("/")[0];
  static rValue = (value) => value && value.includes("/") && value.split("/")[1];

  static checkDMY = (value, type) => {
    if (value !== '') {
      if (isNaN(value)) return false;
      if (value < 1) return false;
      switch (type) {
        case 'M':
          if (value > 12) return false;
          break;
        case 'Y':
          if (value > 2999) return false;
          break;
        default:
          if (value > 31) return false;
          break;
      }
    }
    return true;
  }

  leftOnChangeHandler = (e) => {
    if (!InputDayMonth.checkDMY(e.target.value, this.props.ltype)) return false;
    this.setState({ leftValue: e.target.value });
    if (this.props.onChange && typeof this.props.onChange === 'function') {
      this.props.onChange(`${e.target.value}/${this.state.rightValue}`)
    }
  }

  rightOnChangeHandler = (e) => {
    if (!InputDayMonth.checkDMY(e.target.value, this.props.rtype)) return false;
    this.setState({ rightValue: e.target.value });
    if (this.props.onChange && typeof this.props.onChange === 'function') {
      this.props.onChange(`${this.state.leftValue}/${e.target.value}`)
    }
  }

  render() {
    return (
      <Input.Group className={"InputDayMonth" + (this.props.disabled ? " disabled" : "")}>
        <div className="l">
          <Input
            placeholder={this.props.lplaceholder}
            onChange={this.leftOnChangeHandler}
            ref={leftInput => this.leftInput = leftInput}
            disabled={this.props.disabled}
            type="number"
            style={{ textAlign: "right" }}
            value={this.state.leftValue}
            min={this.props.lmin}
            max={this.props.lmax}
            className={`type_${this.props.ltype}`}
            name={this.props.name && `l_${this.props.name}`} />
        </div>
        <div className="r" >
          <Input
            placeholder={this.props.rplaceholder}
            onChange={this.rightOnChangeHandler}
            ref={rightInput => this.rightInput = rightInput}
            disabled={this.props.disabled}
            type="number"
            style={{ textAlign: "left" }}
            value={this.state.rightValue}
            min={this.props.rmin}
            max={this.props.rmax}
            className={`type_${this.props.rtype}`}
            name={this.props.name && `r_${this.props.name}`} />
        </div>
      </Input.Group>
    )
  }
}


// WEBPACK FOOTER //
// ./src/commonComponents/InputDayMonth/InputDayMonth.js